import { useState, useEffect } from 'react';
import api from '../services/api';

/**
 * Custom hook for fetching and managing user preferences
 */
export const useUserPreferences = () => {
  const [preferences, setPreferences] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchPreferences = async () => {
    try {
      setLoading(true);
      setError(null);
      
      const response = await api.get('/api/trip-preferences');
      const prefs = response.data.preferences || response.data;
      
      // Set defaults if any preferences are missing
      const defaultPreferences = {
        speed_unit: 'knots',
        distance_unit: 'nautical_miles',
        temperature_units: 'celsius',
        fuel_units: 'liters',
        ...prefs
      };
      
      setPreferences(defaultPreferences);
    } catch (error) {
      console.error('Error fetching user preferences:', error);
      setError(error);
      
      // Set fallback defaults
      setPreferences({
        speed_unit: 'knots',
        distance_unit: 'nautical_miles',
        temperature_units: 'celsius',
        fuel_units: 'liters'
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPreferences();
  }, []);

  const updatePreferences = async (newPreferences) => {
    try {
      await api.put('/api/trip-preferences', newPreferences);
      setPreferences(prev => ({ ...prev, ...newPreferences }));
      return { success: true };
    } catch (error) {
      console.error('Error updating preferences:', error);
      return { success: false, error };
    }
  };

  return {
    preferences,
    loading,
    error,
    refetch: fetchPreferences,
    updatePreferences
  };
};
